import dayjs, { Dayjs } from 'dayjs';

export type DateRangeShortcutsItem = {
  labelKey: string;
  getValue: () => [Dayjs | null, Dayjs | null];
};

export type WeekDay = 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday';
export type WeekDayShort = 'sun' | 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat';

export type RegionInfo = {
  city: string; //  'Port Maceyfort';
  state: string; //  'ME';
};

export type Address = RegionInfo & {
  firstAddress: string; //  '8823 Jevon Flat';
  secondAddress: string; //  'Suite 185';
  zipCode: string; //  '39620';
};

export type AddressDetails = Address & {
  region: string;
};

export type PaginatedResponse<T> = {
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  items: T;
};

export const dateRangeShortcuts: DateRangeShortcutsItem[] = [
  {
    labelKey: 'filters.dateRange.previousQuarter',
    getValue: () => {
      const today = dayjs();
      const startOfPrevQuarter = today.subtract(1, 'quarter' as any).startOf('quarter' as any);
      return [startOfPrevQuarter, startOfPrevQuarter.endOf('quarter' as any)];
    },
  },
  {
    labelKey: 'filters.dateRange.previousWeek',
    getValue: () => {
      const today = dayjs();
      const startOfPrev = today.subtract(1, 'week').startOf('week');
      return [startOfPrev, startOfPrev.endOf('week')];
    },
  },
  {
    labelKey: 'filters.dateRange.today',
    getValue: () => {
      const today = dayjs().startOf('day');
      return [today, today.endOf('day')];
    },
  },
  {
    labelKey: 'filters.dateRange.thisWeek',
    getValue: () => {
      const today = dayjs();
      return [today.startOf('week'), today.endOf('week')];
    },
  },
  {
    labelKey: 'filters.dateRange.thisQuarter',
    getValue: () => {
      const today = dayjs();
      const startOfPrevQuarter = today.startOf('quarter' as any);
      return [startOfPrevQuarter, startOfPrevQuarter.endOf('quarter' as any)];
    },
  },
  {
    labelKey: 'filters.dateRange.nextWeek',
    getValue: () => {
      const today = dayjs();
      const startOfPrev = today.add(1, 'week').startOf('week');
      return [startOfPrev, startOfPrev.endOf('week')];
    },
  },
  {
    labelKey: 'filters.dateRange.nextQuarter',
    getValue: () => {
      const today = dayjs();
      const startOfPrevQuarter = today.add(1, 'quarter' as any).startOf('quarter' as any);
      return [startOfPrevQuarter, startOfPrevQuarter.endOf('quarter' as any)];
    },
  },
  { labelKey: 'common.all', getValue: () => [null, null] },
];
